import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import classes from "./customer.module.css";
import { Paper, Typography, Tooltip } from "@mui/material";
import EditCustomerModal from "./EditCustomerModal";
import { fetchCustomer } from "../../../Redux/actions/customerActions";
import {
  CusCallIcon,
  CusEditPenIcon,
  CusMailIcon,
} from "../../../Components/Icons/Icons";

const CustomerCard = (props) => {
  const customerData = useSelector((state) => state.customerData.customer);
  const { email, mobile_number, designation, first_name, last_name } =customerData || {};
  const dispatch = useDispatch();
  const [showPopup, setShowPopup] = useState(false);

  const closeHandler = (props) => {
    getCustomer();
    setShowPopup(false);
  };

  const getCustomer = () => {
    const path = window.location.pathname;
    const arr = path.split("/");
    console.log(arr);
    dispatch(fetchCustomer(arr[arr.length - 1]));
  };

  useEffect(() => {
    const path = window.location.pathname;
    const arr = path.split("/");
    console.log(arr);
    dispatch(fetchCustomer(arr[arr.length - 1]));
  }, [dispatch]);
  return (
    <div>
      <Paper elevation={0} className={classes.profileCard}>
        <div className={classes.customerCardMainDiv}>
          <div className="d-flex flex-column" style={{gap:"8px"}}>
            <Typography
              className={`${classes.cardHeading} mb-2`}
            >{`${first_name?first_name:""} ${last_name?last_name:""}`}</Typography>
            <Typography className={`${classes.cardSubHeading}`}>
              <b>Designation:</b> {designation&&designation}
            </Typography>
            <div className={classes.displayFlex} style={{ columnGap: "8px" }}>
              <Typography
                component="a"
                href={mobile_number ? `tel:${mobile_number}` : undefined}
                className={`${classes.displayFlex} ${classes.contactLink}`}
              >
                <CusCallIcon /> <span>{mobile_number && mobile_number}</span>
              </Typography>{" "}
              |
              <Tooltip title={email} arrow >
                <Typography
                  component="a"
                  href={email ? `mailto:${email}` : undefined}
                  className={`${classes.displayFlex} ${classes.contactLink}`}
                >
                  <CusMailIcon /> <span className={classes.emailFeild} >{email && email }</span>
                </Typography>
              </Tooltip>


            </div>
          </div>
          <Typography
            className={classes.EditButton}
            onClick={() => setShowPopup(true)}
          >
            <CusEditPenIcon /> <span>Edit</span>
          </Typography>
        </div>
      </Paper>
      {showPopup ? (
        <EditCustomerModal
          handleClose={closeHandler}
          /* handleSubmit={SubmitHandler} */ values={customerData}
        />
      ) : null}
    </div>
  );
};

export default CustomerCard;
